"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var siteSectionBaseTheme = function (_a) {
    var _b, _c, _d, _e;
    var MAX_XS = _a.MAX_XS, MAX_S = _a.MAX_S, MIN_S = _a.MIN_S, MAX_M = _a.MAX_M, MAX_L = _a.MAX_L, MAX_XL = _a.MAX_XL;
    return ({
        siteSectionTiles: {},
        siteSectionTilesLinks: (_b = {
                display: "grid",
                gridAutoRows: "minmax(6rem, max-content)",
                gridTemplateColumns: "repeat(5, 1fr)",
                gridGap: "1rem"
            },
            _b[MAX_XL] = {
                gridTemplateColumns: "repeat(4, 1fr)",
            },
            _b[MAX_L] = {
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _b[MAX_M] = {
                gridGap: "0.5rem",
                gridAutoRows: "minmax(3rem, max-content)",
                gridTemplateColumns: "repeat(2, 1fr)",
                paddingBottom: "2rem",
            },
            _b[MAX_XS] = {
                gridTemplateColumns: "repeat(1, 1fr)",
                paddingBottom: "1rem",
            },
            _b),
        siteSectionTilesTitle: (_c = {
                fontSize: "2rem",
                lineHeight: "3rem",
                textTransform: 'capitalize',
                display: "flex",
                "& i18n-message": {
                    marginLeft: "0.5rem",
                }
            },
            _c[MAX_S] = {
                fontSize: "16px",
                textAlign: "left",
                fontWeight: "bolder",
                marginTop: '0.5rem',
                flex: 1,
            },
            _c),
        siteSectionTilesContainer: {},
        siteSectionTilesWrapper: {
            display: "flex",
            flex: 1,
            flexDirection: "row",
            marginBottom: "5px"
        },
        siteSectionTilesIcon: {
            width: "30px",
            height: "30px",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            "&> img": {
                height: "100%",
            }
        },
        siteSectionIcon: (_d = {},
            _d[MIN_S] = {
                width: "auto",
                height: "2rem"
            },
            _d[MAX_S] = {
                display: "none !important"
            },
            _d),
        siteSectionHref: (_e = {
                display: "flex",
                flexBasis: "calc(20% - 2rem)",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "start",
                textDecoration: "none",
                overflowWrap: "break-word",
                boxSizing: "border-box",
                justifyContent: "center",
                borderRadius: "0.25rem",
                padding: "1rem"
            },
            _e[MAX_L] = {
                flexBasis: "calc(25% - 2rem)",
            },
            _e[MAX_M] = {
                margin: "0.5rem",
                flexBasis: "calc(33.3% - 1rem)",
            },
            _e[MAX_XS] = {
                margin: "0",
                flexBasis: "100%",
            },
            _e),
        siteSectionText: {
            fontWeight: "normal",
            marginTop: "0.25rem",
            textAlign: "center",
        },
        siteSection: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            "& > *:not(:last-child)": {
                marginRight: "2.5rem",
            }
        },
        siteSectionTextWrapper: {
            color: "inherit",
            display: "flex",
            flexDirection: "column",
        },
        siteSectionDescription: {},
        siteSectionIndexContent: {
            marginLeft: "0.5rem",
            "& .title": {
                display: "none"
            }
        }
    });
};
exports.default = siteSectionBaseTheme;
//# sourceMappingURL=siteSection.js.map